export type Route =
  | { kind: "verify"; stampId: string }
  | { kind: "offline" }
  | { kind: "notfound" };

const STAMP_ID_PATH = /^\/v\/([A-Z2-7]{9})\/?$/;

export function parseRoute(pathname: string): Route {
  if (pathname === "/v/offline" || pathname === "/v/offline/") {
    return { kind: "offline" };
  }
  const match = STAMP_ID_PATH.exec(pathname);
  if (match?.[1]) {
    return { kind: "verify", stampId: match[1] };
  }
  return { kind: "notfound" };
}
